export const emptySearchModel = {
  search: '',
  filters: {
    location: [],
    industries: [],
    skills: [],
    company: {
      annual_revenue: [],
      number_of_employees: [],
      corporate_structure: []
    },
    education: [],
    profession: []
  },
  per_page: 50,
  page: 1
};
